//libs
import isEmpty from 'lodash/isEmpty';
import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router';
import { useSelector } from 'react-redux';

//selectors
import {
  getTitle,
  getImpressiveProducts,
  getQueryExpansionTerm,
  getQueryExpansionType,
  getCategoryId,
  getIsBrand,
  getLocation,
  getFilterGuides,
  getIsOfferPage,
  getMerchandisingDetails,
  getTotalCount,
  getProducts,
  getEntityData,
  getTrackingMetadata,
  getAdPlatformWidgets,
} from 'store/listingV2/selectors';

//helpers
import { isSearchPage } from 'shared/store/listingV2/helpers';
import { onPageLoad, onSearchPageLoad, onOfferPageLoad } from './helpers';
import {
  getSearchPageloadDataFromUrl,
  getCategoryPageLoadData,
} from 'shared/layouts/Listing/components/Analytics/helpers';

//hooks
import { useRemoteConfig } from 'shared/store/remoteConfigs/hooks';

export default function AnalyticsV2() {
  const params = useParams<Record<string, string>>();
  const routeParams = params[0];
  const { pathname } = useSelector(getLocation);
  const isSearch = isSearchPage(pathname);
  const title = useSelector(getTitle);
  const isBrand = useSelector(getIsBrand);
  const impressiveProducts = useSelector(getImpressiveProducts);
  const queryExpansionTerm = useSelector(getQueryExpansionTerm);
  const queryExpansionType = useSelector(getQueryExpansionType);
  const { desktop: isPriceReveal, salePromotionConfig } = useRemoteConfig('priceReveal');
  const isSalePriceLiveEnabled = salePromotionConfig.desktop;
  const { plp: isFomoTimer } = useRemoteConfig('fomoTimer');
  const categoryId = useSelector(getCategoryId);
  const filterGuides = useSelector(getFilterGuides);
  const isOfferPage = useSelector(getIsOfferPage);
  const merchandisingDetails = useSelector(getMerchandisingDetails);
  const guidesAvailable = !isEmpty(filterGuides);
  const { search } = useLocation();
  const totalCount = useSelector(getTotalCount);
  const products = useSelector(getProducts);
  const entityData = useSelector(getEntityData);
  const trackingMetadata = useSelector(getTrackingMetadata);
  const adPlatformPageType = useSelector(getAdPlatformWidgets).pageType;
  const pagePayload = getSearchPageloadDataFromUrl({
    totalCount,
    entityData,
    queryExpansionTerm,
    queryExpansionType,
    search,
    isPriceRevealEnabled: isPriceReveal,
    isSalePriceLiveEnabled: isSalePriceLiveEnabled,
    products,
    merchandisingDetails,
    adPlatformPageType,
    trackingMetadata,
  });

  useEffect(() => {
    //for search pages
    if (isSearch) {
      if (impressiveProducts !== undefined)
        onSearchPageLoad({
          title,
          pagePayload,
        });

      return;
    }
    //for non search pages
    const analyticsParams = {
      routeParams,
      guidesAvailable,
      categoryId,
      id: params.id,
    };

    //category params
    const categoryPageData = getCategoryPageLoadData(
      products,
      isBrand,
      title,
      filterGuides,
      isPriceReveal,
      isSalePriceLiveEnabled,
      isFomoTimer?.enable
    );
    onPageLoad({
      title,
      isBrand,
      params: analyticsParams,
      pagePayload,
      categoryPageData,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isOfferPage) onOfferPageLoad();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
